import { Input, Select, Td, Tr } from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { OptionType } from "models/select_mode";

interface IProductInputRow {
  unidade: string;
  changeInput: (tipo: string, valor: string) => void;
  unidadeRef: any;
  unidades: ClientClassificationType[] | undefined;
  descricao: string;
  diasPgto: string;
  valorMin: string;
  valorMax: string;
  principal: boolean;
  add: () => void;
  condicaoPagamentos : CondicaoPagamento[] | undefined;
  condicaoPagamentoId: string;
}

const ProductInputRow = ({
  unidade,
  changeInput,
  unidadeRef,
  unidades,
  add,
  descricao,
  diasPgto,
  valorMax,
  valorMin,
  principal,
  condicaoPagamentos,
  condicaoPagamentoId
}: IProductInputRow) => {
  return (
    <Tr>
      <Td fontSize={{ sm: "14px" }} borderColor="transparent" w={300}>
        <AutoComplete<OptionType, false, GroupBase<OptionType>>
          size="md"
          onChange={(e) => changeInput("unidade", e.value)}
          placeholder="Buscar..."
          ref={unidadeRef}
          name={"Unidade"}
          options={unidades?.map((item) => {
            return {
              label: item.nome,
              value: item.id,
            };
          })}
          defaultValue={{
            label: "",
            value: unidade
            }}
        />
      </Td>

      <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={300}>
        <Input
          isRequired={false}
          fontSize="sm"
          value={descricao}
          ms={{ base: "0px", md: "0px" }}
          type="text"
          placeholder="Descrição"
          fontWeight="500"
          border={"none"}
          size="md"
          onChange={(e) => changeInput("descricao", e.target.value)}
        />
      </Td>

      <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={300}>
      <AutoComplete<OptionType, false, GroupBase<OptionType>>
          size="md"
          onChange={(e) => changeInput("pagamento", e.value)}
          placeholder="Buscar..."
          ref={unidadeRef}
          name={"Condicaopagamento"}
          options={condicaoPagamentos?.map((item) => {
            return {
              label: item.nome,
              value: item.id,
            };
          })}
          defaultValue={{
            label: "",
            value: condicaoPagamentoId
            }}
        />
      </Td>
      <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={180}>
        <Select value={principal.toString()}   onChange={(e) => changeInput("principal", e.target.value)}>
           <option value={'false'}>NÃO</option>
            <option value={'true'}>SIM</option>
        </Select>
      </Td>

      <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={180}>
        <Input
          isRequired={false}
          fontSize="sm"
          value={valorMin}
          ms={{ base: "0px", md: "0px" }}
          type="text"
          placeholder="Valor Min"
          fontWeight="500"
          border={"none"}
          size="md"
          onChange={(e) => changeInput("valorMin", e.target.value)}
        />
      </Td>
      <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={180}>
        <Input
          isRequired={false}
          fontSize="sm"
          value={valorMax}
          ms={{ base: "0px", md: "0px" }}
          type="text"
          placeholder="Valor Max"
          fontWeight="500"
          border={"none"}
          size="md"
          onBlur={() => {
            add();
          }}
          onChange={(e) => changeInput("valorMax", e.target.value)}
        />
      </Td>
      <Td fontSize={{ sm: "14px" }} borderColor="transparent"></Td>
    </Tr>
  );
};

export default ProductInputRow;
